<template>
  <div class="components-forum-category-item">
    <button
      class="btn btn-block btn-category py-0 pl-0"
      @click="$emit('select-item')"
    >
      <div
        class="d-flex justify-content-start align-items-center m-0 pl-1"
        :class="{ 'border-img': !selected, 'bg-active': selected }"
      >
        <i
          :class="`${icon} mr-2 ${selected ? 'text-dark' : 'text-success'}`"
        ></i>
        <p class="m-0 categories">
          {{ title }}
        </p>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "CategoryItemFeed",
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.components-forum-category-item {
  height: 40px;
  button {
    background: none;
    border: none;
    color: #ffffff;
  }

  .btn-category {
    height: 35px;
  }

  .border-img,
  .bg-active {
    width: 100%;
    height: 35px;
    border-radius: 8px;
  }
  .bg-active {
    background-color: #2db563;
    border: none;
  }

  i {
    font-size: 20px;
  }

  .categories {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }
}
</style>
